(()=>{
  const init=()=>{
    const d=document.querySelector('[data-drawer]');
    const o=document.querySelector('[data-menu-open]');
    const c=document.querySelector('[data-menu-close]');
    if(d&&o){
      const set=v=>{d.hidden=!v;document.body.classList.toggle('bb-lock',v);o.setAttribute('aria-expanded',String(v));};
      o.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();set(true);});
      c?.addEventListener('click',()=>set(false));
      d.addEventListener('click',e=>{if(e.target===d)set(false);});
      d.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>set(false)));
      d.querySelectorAll('button[name=language_code]').forEach(b=>b.addEventListener('click',()=>set(false)));
      document.addEventListener('keydown',e=>{if(e.key==='Escape')set(false);});
    }

    const key='bodybu-wishlist';
    const read=()=>{try{const raw=JSON.parse(localStorage.getItem(key)||'[]'); return Array.isArray(raw)?raw:[]}catch(e){return []}};
    const write=a=>localStorage.setItem(key,JSON.stringify(a));
    const normalize=()=>{
      let a=read();
      // Migrate the old ID-only format to an empty structured list; new clicks will save full product data.
      if(a.length && typeof a[0] !== 'object'){a=[];write(a)}
      return a;
    };
    const updateHeader=()=>{
      const count=document.querySelector('[data-wishlist-count]'); if(!count)return;
      const n=normalize().length; count.textContent=n; count.hidden=n===0;
    };
    const syncButtons=()=>{
      const a=normalize();
      document.querySelectorAll('[data-wishlist-id]').forEach(b=>{
        const saved=a.some(x=>String(x.id)===String(b.dataset.wishlistId));
        b.classList.toggle('is-saved',saved); b.setAttribute('aria-pressed',String(saved));
        b.setAttribute('aria-label',saved?'Rimuovi dai preferiti':'Aggiungi ai preferiti');
      });
    };
    document.querySelectorAll('[data-wishlist-id]').forEach(b=>{
      b.addEventListener('click',e=>{
        e.preventDefault(); e.stopPropagation();
        let a=normalize(); const id=String(b.dataset.wishlistId);
        const exists=a.some(x=>String(x.id)===id);
        if(exists) a=a.filter(x=>String(x.id)!==id);
        else a.push({id:id,url:b.dataset.wishlistUrl,title:b.dataset.wishlistTitle,image:b.dataset.wishlistImage,price:b.dataset.wishlistPrice});
        write(a); syncButtons(); updateHeader(); renderWishlistPage();
      });
    });
    const renderWishlistPage=()=>{
      const grid=document.querySelector('[data-wishlist-grid]'); const empty=document.querySelector('[data-wishlist-empty]');
      if(!grid)return;
      const a=normalize(); grid.innerHTML='';
      if(!a.length){empty.hidden=false;return} empty.hidden=true;
      const removeLabel=(document.documentElement.lang||'it').startsWith('fr')?'Retirer':(document.documentElement.lang||'it').startsWith('en')?'Remove':'Rimuovi';
      a.forEach(x=>{
        const item=document.createElement('article'); item.className='bb-wishlist-item';
        item.innerHTML=`<div class="bb-wishlist-item__image"><a href="${x.url}">${x.image?`<img src="${x.image}" alt="${x.title||''}" loading="lazy">`:''}</a><button class="bb-wishlist bb-wishlist--saved" type="button" aria-label="${removeLabel}">♥</button></div><div class="bb-wishlist-item__meta"><a href="${x.url}">${x.title||''}</a><span>${x.price||''}</span></div>`;
        item.querySelector('button').addEventListener('click',()=>{write(a.filter(y=>String(y.id)!==String(x.id)));renderWishlistPage();syncButtons();updateHeader();});
        grid.appendChild(item);
      });
    };
    renderWishlistPage(); syncButtons(); updateHeader();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* BodyBu newsletter popup */
document.addEventListener('DOMContentLoaded',function(){
  if(!document.body.classList.contains('template-index'))return;
  var p=document.querySelector('[data-newsletter-popup]'); if(!p)return;
  var e=p.querySelector('.bb-newsletter-popup__input');
  var key='bodybu_newsletter_seen_v5';
  var preview=(new URLSearchParams(window.location.search)).has('preview_theme_id') || (window.Shopify && Shopify.designMode) || (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');

  function close(){
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden','true');
  }

  function open(){
    p.classList.add('is-open');
    p.setAttribute('aria-hidden','false');
    try{sessionStorage.setItem(key,'1')}catch(err){}
    if(e)setTimeout(function(){e.focus()},150);
  }

  p.querySelectorAll('[data-newsletter-close]').forEach(function(b){b.addEventListener('click',close)});
  document.addEventListener('keydown',function(x){if(x.key==='Escape')close()});

  var shouldShow=true;
  if(!preview){
    try{
      shouldShow=!sessionStorage.getItem(key);
    }catch(err){shouldShow=true}
  }

  if(shouldShow){
    setTimeout(open, preview ? 700 : 4000);
  }
});

/* BodyBu sticky add-to-cart */
document.addEventListener('DOMContentLoaded',function(){
  var bar=document.querySelector('[data-sticky-atc]');
  if(!bar)return;
  var add=bar.querySelector('[data-sticky-add]');
  var productForm=document.querySelector('form[action*="/cart/add"]');
  if(!add||!productForm)return;

  function selectedId(){
    var input=productForm.querySelector('input[name="id"], select[name="id"]');
    return input ? input.value : null;
  }
  function update(){
    var rect=productForm.getBoundingClientRect();
    var visible=rect.bottom>0 && rect.top<window.innerHeight;
    bar.classList.toggle('is-visible',!visible);
    bar.setAttribute('aria-hidden',visible?'true':'false');
    var id=selectedId();
    add.disabled=!id;
  }
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  productForm.addEventListener('change',update);
  update();

  add.addEventListener('click',function(){
    var id=selectedId();
    if(!id)return;
    var fd=new FormData();
    fd.append('id',id); fd.append('quantity','1');
    add.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
      .then(function(){
        add.disabled=false;
        window.location.href='/cart';
      })
      .catch(function(){
        add.disabled=false;
        productForm.requestSubmit ? productForm.requestSubmit() : productForm.submit();
      });
  });
});

document.addEventListener('DOMContentLoaded',function(){
var root=document.querySelector('[data-bb-product]');if(!root)return;
var form=document.getElementById('BodyBuProductForm'),data=document.querySelector('[data-bb-variants]');if(!form||!data)return;
var variants=[];try{variants=JSON.parse(data.textContent||'[]')}catch(e){return}
var hidden=form.querySelector('[data-bb-variant-id]'),price=document.querySelector('[data-bb-price]'),stickyPrice=document.querySelector('[data-bb-sticky-price]'),add=form.querySelector('[data-bb-add]'),error=form.querySelector('[data-bb-product-error]');
function selected(){return Array.from(form.querySelectorAll('[data-bb-option]')).map(function(g){var c=g.querySelector('input[type=radio]:checked');return c?c.value:null})}
function same(a,b){return a.length===b.length&&a.every(function(v,i){return String(v)===String(b[i])})}
function update(){var opts=selected(),v=variants.find(function(x){return same(x.options,opts)});if(!v){error.hidden=false;add.disabled=true;return}error.hidden=true;hidden.value=v.id;if(price)price.textContent=v.price;if(stickyPrice)stickyPrice.textContent=v.price;add.disabled=!v.available;add.textContent=v.available?(add.dataset.labelAdd||'ADD TO CART'):(add.dataset.labelSold||'SOLD OUT');var st=document.querySelector('[data-sticky-add]');if(st)st.disabled=!v.available;if(v.mediaId){var m=document.querySelector('[data-media-id="'+v.mediaId+'"]'),g=document.querySelector('[data-bb-gallery]');if(m&&g){g.prepend(m);g.querySelectorAll('[data-media-id]').forEach(function(x){x.classList.toggle('is-selected',x===m)});if(window.innerWidth<901)m.scrollIntoView({behavior:'smooth',block:'nearest'})}}var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString())}
form.querySelectorAll('input[type=radio]').forEach(function(i){i.addEventListener('change',update)});update();
});
/* BodyBu newsletter premium carousel */
document.addEventListener('DOMContentLoaded',function(){
  var popup=document.querySelector('[data-newsletter-popup]');
  if(!popup)return;
  var track=popup.querySelector('[data-newsletter-track]');
  var next=popup.querySelector('[data-newsletter-next]');
  var dots=Array.from(popup.querySelectorAll('.bb-newsletter-carousel__dots span'));
  if(!track)return;

  function cards(){return Array.from(track.querySelectorAll('.bb-newsletter-card'))}
  function currentIndex(){
    var a=cards(); if(!a.length)return 0;
    var left=track.scrollLeft;
    var best=0,dist=Infinity;
    a.forEach(function(card,i){
      var d=Math.abs(card.offsetLeft-left);
      if(d<dist){dist=d;best=i}
    });
    return best;
  }
  function updateDots(){
    var i=currentIndex();
    dots.forEach(function(d,n){d.classList.toggle('is-active',n===i)});
  }
  function goNext(){
    var a=cards(); if(a.length<2)return;
    var i=currentIndex();
    var ni=(i+1)%a.length;
    track.scrollTo({left:a[ni].offsetLeft,behavior:'smooth'});
    setTimeout(updateDots,350);
  }
  next?.addEventListener('click',goNext);
  track.addEventListener('scroll',function(){window.clearTimeout(track._bbt);track._bbt=window.setTimeout(updateDots,90)},{passive:true});

  var timer=window.setInterval(function(){
    if(popup.classList.contains('is-open'))goNext();
  },3600);
  window.addEventListener('pagehide',function(){window.clearInterval(timer)});
});

/* BodyBu resilient drawer fallback v2 */
(function(){
  if(window.__bodyBuDrawerFallbackV2)return;
  window.__bodyBuDrawerFallbackV2=true;

  function getDrawer(){return document.querySelector('[data-drawer]');}
  function getOpen(){return document.querySelector('[data-menu-open]');}
  function setDrawer(open){
    var drawer=getDrawer(), trigger=getOpen();
    if(!drawer)return;
    if(open){
      drawer.hidden=false;
      drawer.removeAttribute('hidden');
      document.documentElement.classList.add('bb-menu-open');
      document.body.classList.add('bb-lock');
    }else{
      drawer.hidden=true;
      drawer.setAttribute('hidden','');
      document.documentElement.classList.remove('bb-menu-open');
      document.body.classList.remove('bb-lock');
    }
    if(trigger)trigger.setAttribute('aria-expanded',open?'true':'false');
  }

  document.addEventListener('click',function(e){
    var open=e.target.closest&&e.target.closest('[data-menu-open]');
    if(open){e.preventDefault();e.stopPropagation();setDrawer(true);return;}
    var close=e.target.closest&&e.target.closest('[data-menu-close]');
    if(close){e.preventDefault();setDrawer(false);return;}
    var drawer=getDrawer();
    if(drawer&&e.target===drawer){setDrawer(false);return;}
    if(drawer&&!drawer.hidden&&e.target.closest&&e.target.closest('.bodybu-drawer__nav a'))setDrawer(false);
  },true);

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')setDrawer(false);
  });
})();
